import React, { SVGProps } from 'react';

/**
 * XCircle Icon Component (Localized from @praetorian-chariot/ui)
 *
 * Represents an error or critical status with a circle-X design.
 * Commonly used in status badges and error indicators.
 *
 * This component was localized to fix React DOM property warnings
 * and to reduce dependency on the external UI library.
 *
 * @example
 * ```tsx
 * <XCircleIcon className="w-4 h-4 text-red-500" />
 * ```
 */
export const XCircleIcon: React.FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx={12} cy={12} r={10} />
      <line x1={15} y1={9} x2={9} y2={15} />
      <line x1={9} y1={9} x2={15} y2={15} />
    </svg>
  );
};
